'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactTransitionGroup = require('react-transition-group');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

require('./carousel.scss');

var _icon = require('../icon/icon');

var _icon2 = _interopRequireDefault(_icon);

var _classnames = require('../../utils/classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DIRECTION_PREV = 'prev';
var DIRECTION_NEXT = 'next';
var ANIMATION_TIMEOUT = 500;
var SWIPE_LENGTH = 50;

var Carousel = function (_React$Component) {
  _inherits(Carousel, _React$Component);

  function Carousel(props) {
    _classCallCheck(this, Carousel);

    var _this = _possibleConstructorReturn(this, (Carousel.__proto__ || Object.getPrototypeOf(Carousel)).call(this, props));

    _this.state = {
      activeIndex: 0
    };

    _this.goToSlide = _this.goToSlide.bind(_this);
    _this.goToPrevSlide = _this.goToPrevSlide.bind(_this);
    _this.goToNextSlide = _this.goToNextSlide.bind(_this);

    _this.onTouchStart = _this.onTouchStart.bind(_this);
    _this.onTouchMove = _this.onTouchMove.bind(_this);
    _this.onTouchEnd = _this.onTouchEnd.bind(_this);
    return _this;
  }

  _createClass(Carousel, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.goToSlide(this.props.initialSlide);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (prevProps.initialSlide !== this.props.initialSlide) {
        this.goToSlide(this.props.initialSlide);
      }
    }
  }, {
    key: 'onTouchStart',
    value: function onTouchStart(event) {
      this.initialClientXLocation = event.touches[0].clientX;

      this.onTouchMove(event);
    }
  }, {
    key: 'onTouchMove',
    value: function onTouchMove(event) {
      var clientX = event.touches[0].clientX;
      var deltaClientX = clientX - this.initialClientXLocation;

      if (Math.abs(deltaClientX) < SWIPE_LENGTH || this.preventSwipe) {
        return this;
      }

      this.preventSwipe = true;

      return deltaClientX > 0 ? this.goToPrevSlide() : this.goToNextSlide();
    }
  }, {
    key: 'onTouchEnd',
    value: function onTouchEnd() {
      this.preventSwipe = false;
    }
  }, {
    key: 'goToSlide',
    value: function goToSlide(index) {
      var direction = index > this.state.activeIndex ? DIRECTION_NEXT : DIRECTION_PREV;

      this.setState({ activeIndex: index, direction: direction });
    }
  }, {
    key: 'goToPrevSlide',
    value: function goToPrevSlide() {
      var loop = this.props.loop;
      var activeIndex = this.state.activeIndex;


      var slidesLength = this.props.children.length - 1;
      var isFirstIndex = activeIndex === 0;

      if (isFirstIndex && loop === false) {
        return;
      }

      var nextActiveIndex = isFirstIndex ? slidesLength : activeIndex - 1;

      this.setState({ activeIndex: nextActiveIndex, direction: DIRECTION_PREV });
    }
  }, {
    key: 'goToNextSlide',
    value: function goToNextSlide() {
      var loop = this.props.loop;
      var activeIndex = this.state.activeIndex;


      var slidesLength = this.props.children.length - 1;
      var isLastIndex = activeIndex === slidesLength;

      if (isLastIndex && loop === false) {
        return;
      }

      var nextActiveIndex = isLastIndex ? 0 : activeIndex + 1;

      this.setState({ activeIndex: nextActiveIndex, direction: DIRECTION_NEXT });
    }
  }, {
    key: 'renderStartNavigationArrow',
    value: function renderStartNavigationArrow() {
      return _react2.default.createElement(
        'div',
        { className: 'carousel__arrow carousel__arrow--left', onClick: this.goToPrevSlide },
        _react2.default.createElement(_icon2.default, { name: 'arrow-left-thin', size: '18' })
      );
    }
  }, {
    key: 'renderEndNavigationArrow',
    value: function renderEndNavigationArrow() {
      return _react2.default.createElement(
        'div',
        { className: 'carousel__arrow carousel__arrow--right', onClick: this.goToNextSlide },
        _react2.default.createElement(_icon2.default, { name: 'arrow-right-thin', size: '18' })
      );
    }
  }, {
    key: 'renderSlideIndicators',
    value: function renderSlideIndicators() {
      var _this2 = this;

      var slides = this.props.children;

      return _react2.default.createElement(
        'ul',
        { className: 'carousel__indicators' },
        slides.map(function (slide, index) {
          var classes = (0, _classnames2.default)('carousel__indicator', index === _this2.state.activeIndex && 'carousel__indicator--active');

          return _react2.default.createElement('li', { key: index, className: classes, onClick: function onClick() {
              return _this2.goToSlide(index);
            } });
        })
      );
    }
  }, {
    key: 'renderSlides',
    value: function renderSlides() {
      var _this3 = this;

      var slides = this.props.children;
      var animationClass = this.state.direction === DIRECTION_NEXT ? 'carousel-next-animation-translate' : 'carousel-prev-animation-translate';

      var wrapperClasses = (0, _classnames2.default)('carousel__slides-wrapper', this.props.shadow && 'carousel__slides-wrapper--shadow');

      return _react2.default.createElement(
        'div',
        { className: wrapperClasses },
        _react2.default.createElement(
          'ul',
          { className: 'carousel__slides' },
          slides.map(function (slide, index) {
            var isActive = index === _this3.state.activeIndex;
            var classes = (0, _classnames2.default)('carousel__slide', isActive && 'carousel__slide--active');

            return _react2.default.createElement(
              _reactTransitionGroup.CSSTransition,
              {
                key: index,
                classNames: animationClass,
                timeout: ANIMATION_TIMEOUT,
                'in': isActive
              },
              _react2.default.createElement(
                'li',
                { className: classes },
                slide
              )
            );
          })
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        {
          className: 'carousel',
          onTouchStart: this.onTouchStart,
          onTouchMove: this.onTouchMove,
          onTouchEnd: this.onTouchEnd
        },
        this.renderStartNavigationArrow(),
        this.renderSlides(),
        this.renderEndNavigationArrow(),
        this.renderSlideIndicators()
      );
    }
  }]);

  return Carousel;
}(_react2.default.Component);

Carousel.propTypes = {
  children: _propTypes2.default.node,
  loop: _propTypes2.default.bool,
  shadow: _propTypes2.default.bool,
  initialSlide: _propTypes2.default.number
};

Carousel.defaultProps = {
  children: [],
  loop: false,
  shadow: true,
  initialSlide: 0
};

exports.default = Carousel;